module.exports = __webpack_public_path__ + "img/onlineOrder.35a2a939.png";